import { Injectable } from '@angular/core';
import {
  ApplicationInsights,
  ICustomProperties,
  IDependencyTelemetry,
  IExceptionTelemetry,
  IMetricTelemetry,
  ITraceTelemetry,
} from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';

import { TelemetryService } from './telemetry.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class BrowserTelemetryService extends TelemetryService {
  private readonly angularPlugin = new AngularPlugin();
  private readonly appInsights = new ApplicationInsights({
    config: {
      connectionString: environment.appInsights?.connectionString,
      extensions: [this.angularPlugin],
    },
  });

  private readonly assemblyName = 'ESign.UI';
  private readonly defaultProperties = {
    AssemblyName: this.assemblyName,
    Environment: environment.envName,
  };

  constructor() {
    super();
    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer((envelope) => {
      envelope.tags = envelope.tags || [];
      envelope.tags['ai.cloud.roleName'] = this.assemblyName;
    });
  }

  trackTrace(message: ITraceTelemetry, properties?: ICustomProperties): void {
    this.appInsights.trackTrace(message, {
      ...properties,
      ...this.defaultProperties,
    });
  }

  trackDependencyData(dependency: IDependencyTelemetry): void {
    this.appInsights.trackDependencyData(dependency);
  }

  trackMetric(metric: IMetricTelemetry, properties?: ICustomProperties): void {
    this.appInsights.trackMetric(metric, {
      ...properties,
      ...this.defaultProperties,
    });
  }

  trackException(
    exception: IExceptionTelemetry,
    properties?: ICustomProperties,
  ): void {
    this.appInsights.trackException(exception, {
      ...properties,
      ...this.defaultProperties,
    });
  }

  flush(): void {
    this.appInsights.flush();
  }
}
